import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { getAnalytics } from "../../services/apiServices";

function AnalyticsAndReporting() {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAnalyticsData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getAnalytics();

      if (response?.success && response?.data) {
        setAnalyticsData(response.data);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Error fetching analytics:', err);
      setError('Failed to load analytics data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  if (loading) {
    return (
      <div className="right-section anytics-page">
        <div className="text-center py-5">Loading analytics data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="right-section anytics-page">
        <div className="alert alert-danger text-center py-5" role="alert">
          {error}
          <button
            className="btn btn-outline-danger ms-3"
            onClick={fetchAnalyticsData}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  const { overview, resumeAnalytics, videoCallAnalytics, topResumeSenders } = analyticsData || {};
  return (
    <>
      <div className="right-section anytics-page">
        <div className="customer-top justify-content-end">
          <div className="customer-top-right">
            <div className="select-option">
              <div className="selctions-option position-relative">
                {/* <div className="dropdown-cs before-change-cs">Plan Type </div> */}
                {/* <div className="select-dropdown w-100">
                  <ul>
                    <li className="dropdown-item-clear">All</li>
                  </ul>
                </div> */}
              </div>
            </div>
             <div className="select-option">
              <div className="selctions-option position-relative">
                {/* <div className="dropdown-cs before-change-cs">Date Range</div> */}
                {/* <div className="select-dropdown w-100">
                  <ul>
                    <li className="dropdown-item-clear">All</li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
          <div className="anlytics-data">
            <div className="anlytics-column">
            <div className="dashboard-box">
                <span><img src="/images/active-user.svg" alt="icon" /></span>
                <h4>Total Users</h4>
                <h3>{overview?.totalUsers || 0}</h3>
            </div>
            </div>
            <div className="anlytics-column">
            <div className="dashboard-box">
                <span><img src="/images/revenue.svg" alt="icon" /></span>
                <h4>Resumes Submitted</h4>
                <h3>{overview?.resumeSubmissions || 0}</h3>
            </div>
            </div>
            <div className="anlytics-column">
            <div className="dashboard-box">
                <span><img src="/images/active-matches.svg" alt="icon" /></span>
                <h4>Matches Created</h4>
                <h3>{overview?.totalMatches || 0}</h3>
            </div>
            </div>
         <div className="anlytics-column">
            <div className="dashboard-box">
                <span><img src="/images/active-matches.svg" alt="icon" /></span>
                <h4>Scheduled Calls</h4>
                <h3>{overview?.scheduledCalls || 0}</h3>
            </div>
            </div>
           <div className="anlytics-column">
            <div className="dashboard-box">
                <span><img src="/images/active-matches.svg" alt="icon" /></span>
                <h4>Active Premium</h4>
                <h3>{overview?.activePremiumSubscriptions || 0}</h3>
            </div>
            </div>
        </div>
         <div className="media-details report-anlyics mt-0">
       <div className="row">
            <div className="col-md-4">
                  <div className="media-images">
                  <h3 className="media-head">Resume Analytics</h3>
                    <ul className="user-list-data">
                      {resumeAnalytics?.map((item, index) => (
                        <li key={index}>
                          <p>{item.metric}</p>
                          <span><img src={window.getPublicUrl("/images/line.svg")} alt=""/></span>
                          <h4>{item.value}</h4>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="media-images mt-3">
                   <h3 className="media-head ">Video Call Analytics</h3>
                   <ul className="user-list-data">
                     {videoCallAnalytics?.map((item, index) => (
                       <li key={index}>
                         <p>{item.metric}</p>
                         <span><img src={window.getPublicUrl("/images/line.svg")} alt=""/></span>
                         <h4>{item.value}</h4>
                       </li>
                     ))}
                   </ul>
                  </div>
                </div>
         
                
        <div className="col-sm-8">
          {/* <div className="sales-graph">
            <div className="d-flex justify-content-between">
              <h3>Resume Submission</h3>
              <div className="tab">
                <ul>
                  <li className="active">12 Months</li>
                  <li>6 Months</li>
                  <li>30 Days</li>
                  <li>30 Days</li>
                </ul>
              </div>
            </div>
            <div className="graph">
              <img src={window.getPublicUrl('/images/graph.svg')} alt="Submission Graph" />
            </div>
          </div> */}
          <div className="row">
            {/* <div className="col-md-4">
            <div className="sales-graph-active">
            <h3 className="text-center mb-2">Active Subscription Overview</h3>
            <span className="percentage-graph text-center">
              <img src={window.getPublicUrl('/images/overview.svg')} alt="Overview Graph" className="img-fluid" />
            </span>

            <div className="user-stat mb-3">
              <div className="premium-data d-flex justify-content-between">
                <p>
                  <img src={window.getPublicUrl('/images/fav-icon.svg')} className="pr-2" alt="Premium Icon" /> Premium Users
                </p>
                <span>-</span>
                <p>{overview?.activePremiumSubscriptions || 0}</p>
              </div>
            </div>

            <div className="user-stat">
              <div className="premium-data d-flex justify-content-between">
                <p>
                  <img src={window.getPublicUrl('/images/free-user.svg')} className="pr-2" alt="Free User Icon" /> Free Users
                </p>
                <span>-</span>
                <p>{(overview?.totalUsers || 0) - (overview?.activePremiumSubscriptions || 0)}</p>
              </div>
            </div>
            </div>
            </div> */}
               <div className="col-md-12">
                <div class="sales-graph">
					<h3>Top Resume Senders</h3>
					<h4>Users with the highest number of resume submissions.</h4>
          <Link to="/admin/userManagement">
          					<button class="see-all">See All Users <img src="/images/see-all.svg" alt="icon"/></button>

          </Link>
                    <div className="customer-tablle-main mt-3">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="uid">Rank</th>
                                <th className="name">User</th>
                                <th className="plan">Resumes Sent</th>
                                <th className="verified">Account Type</th>
                            </tr>
                        </thead>
                        <tbody>
                          {topResumeSenders?.map((sender) => (
                            <tr key={sender.rank}>
                                <td className="uid">{sender.rank}</td>
                                <td className="name">
                                    <div className="table-mails">
                                       <span className="profile-img">
          <img 
            src={sender.user.image || window.getPublicUrl("/images/john.svg")} 
            alt={sender.user.full_name} 
          />
        </span>
                                        <div>
                                            <h3>{sender.user.full_name}</h3>
                                            <p>{sender.user.email}</p>
                                        </div>
                                    </div>
                                </td>
                                <td className="plan">{sender.resumeCount}</td>
                                <td className="verified">{sender.accountType}</td>
                            </tr>
                          ))}
                        </tbody>
                    </table>
                </div>
				</div>
               </div>
          </div>
        </div>

        </div>
        </div>
      </div>
    </>
  );
}

export default AnalyticsAndReporting;
